import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { UiIcon, UiTooltip } from 'ui-components';
import { getCustomerLabelConfig } from '../../constants/customerLabels';
import { StyledCustomerLabelBadge } from './CustomerLabelBadge.styles';

function CustomerLabelBadge({ label }) {
  const { t } = useTranslation();
  const config = getCustomerLabelConfig(label);

  if (!config) return null;

  return (
    <UiTooltip title={t(config.labelKey)} placement='top'>
      <StyledCustomerLabelBadge bgColor={config.bgColor}>
        <UiIcon src={config.icon} width={16} height={16} />
      </StyledCustomerLabelBadge>
    </UiTooltip>
  );
}

CustomerLabelBadge.propTypes = {
  label: PropTypes.string,
};

export default CustomerLabelBadge;
